import React, { useState } from 'react';
import filterIcon from "../../../../assets/header/eventManagement/icons/filter.png";
import plusIcon from "../../../../assets/header/eventManagement/icons/plus.png";
import searchIcon from "../../../../assets/header/eventManagement/icons/search.png";
import thumbnailIcon from "../../../../assets/header/eventManagement/icons/thumbnail.png";

function Index({ mainHeading, subHeading, btnText, handleBtn, isExportBtn = false, handleFilterData, FilterComponent, filterOptions, handleSearch }) {
    const [showFilter, setShowFilter] = useState(false);

    const [search, setSearch] = useState()

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch(search);
            setSearch('')
        }
    };

    return (
        <div className="bg-[#f8f8f8] w-full  px-4 py-2 flex justify-between items-center">
            {/* Left Section with Event Texts */}
            <div>
                <h1 className="text-xl font-bold text-gray-800">{mainHeading}</h1>
                <p className="text-sm text-gray-600">{subHeading}</p>
            </div>

            {/* Right Section with Search and Icons */}
            <div className="flex items-center space-x-4">
                {/* Search Input */}
                {handleSearch &&
                    <div className="h-16 w-[28rem] flex border items-center border-gray-300 rounded-xl shadow-xl overflow-hidden">
                        <img src={searchIcon} alt="" className="w-5 h-5 mx-3" />
                        <input type="text" className="px-2 py-1 outline-none bg-[#f8f8f8]" placeholder="Search here" onChange={(e) => setSearch(e.target.value)} onKeyDown={handleKeyDown} />
                    </div>
                }

                {/* Notification Icon */}
                {FilterComponent &&
                    <div className="p-2 shadow-xl cursor-pointer hover:bg-gray-200 rounded-xl" onClick={() => setShowFilter(true)}>
                        <img src={filterIcon} alt="" className="p-2" />
                    </div>
                }

                {/* thumbnailIcon Icon */}
                {isExportBtn ? (
                    <div className="btn bg-blue-500 hover:bg-blue-300 w-[3.5rem] h-[3.5rem] shadow-lg rounded-xl flex items-center justify-center" onClick={isExportBtn}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.0625 10.4995V19.4995C20.0625 19.8476 19.9242 20.1814 19.6781 20.4276C19.4319 20.6737 19.0981 20.812 18.75 20.812H5.25C4.9019 20.812 4.56806 20.6737 4.32192 20.4276C4.07578 20.1814 3.9375 19.8476 3.9375 19.4995V10.4995C3.9375 10.1514 4.07578 9.81757 4.32192 9.57143C4.56806 9.32528 4.9019 9.187 5.25 9.187H7.5C7.64918 9.187 7.79226 9.24627 7.89775 9.35176C8.00324 9.45725 8.0625 9.60032 8.0625 9.7495C8.0625 9.89869 8.00324 10.0418 7.89775 10.1473C7.79226 10.2527 7.64918 10.312 7.5 10.312H5.25C5.20027 10.312 5.15258 10.3318 5.11742 10.3669C5.08225 10.4021 5.0625 10.4498 5.0625 10.4995V19.4995C5.0625 19.5492 5.08225 19.5969 5.11742 19.6321C5.15258 19.6672 5.20027 19.687 5.25 19.687H18.75C18.7997 19.687 18.8474 19.6672 18.8826 19.6321C18.9177 19.5969 18.9375 19.5492 18.9375 19.4995V10.4995C18.9375 10.4498 18.9177 10.4021 18.8826 10.3669C18.8474 10.3318 18.7997 10.312 18.75 10.312H16.5C16.3508 10.312 16.2077 10.2527 16.1023 10.1473C15.9968 10.0418 15.9375 9.89869 15.9375 9.7495C15.9375 9.60032 15.9968 9.45725 16.1023 9.35176C16.2077 9.24627 16.3508 9.187 16.5 9.187H18.75C19.0981 9.187 19.4319 9.32528 19.6781 9.57143C19.9242 9.81757 20.0625 10.1514 20.0625 10.4995ZM8.6475 6.397L11.4375 3.60794V12.7495C11.4375 12.8987 11.4968 13.0418 11.6023 13.1473C11.7077 13.2527 11.8508 13.312 12 13.312C12.1492 13.312 12.2923 13.2527 12.3977 13.1473C12.5032 13.0418 12.5625 12.8987 12.5625 12.7495V3.60794L15.3525 6.397C15.404 6.45227 15.4661 6.4966 15.5351 6.52734C15.6041 6.55808 15.6786 6.57462 15.7541 6.57595C15.8296 6.57728 15.9047 6.56339 15.9747 6.5351C16.0447 6.50681 16.1084 6.4647 16.1618 6.41128C16.2152 6.35787 16.2573 6.29424 16.2856 6.2242C16.3139 6.15416 16.3278 6.07914 16.3264 6.00361C16.3251 5.92809 16.3086 5.8536 16.2778 5.7846C16.2471 5.7156 16.2028 5.6535 16.1475 5.602L12.3975 1.85201C12.292 1.74667 12.1491 1.6875 12 1.6875C11.8509 1.6875 11.708 1.74667 11.6025 1.85201L7.8525 5.602C7.79724 5.6535 7.75291 5.7156 7.72216 5.7846C7.69142 5.8536 7.67489 5.92809 7.67356 6.00361C7.67222 6.07914 7.68612 6.15416 7.71441 6.2242C7.7427 6.29424 7.78481 6.35787 7.83822 6.41128C7.89164 6.4647 7.95526 6.50681 8.0253 6.5351C8.09534 6.56339 8.17036 6.57728 8.24589 6.57595C8.32142 6.57462 8.3959 6.55808 8.4649 6.52734C8.5339 6.4966 8.596 6.45227 8.6475 6.397Z" fill="white" />
                        </svg>
                    </div>
                ) : (
                    <div className="p-2 shadow-xl cursor-pointer hover:bg-gray-200 rounded-xl">
                        <img src={thumbnailIcon} alt="" className="p-2" />
                    </div>
                )}

                {/* Action Button */}
                {btnText &&
                    <div onClick={handleBtn} className="flex items-center h-16 gap-3 px-4 py-2 text-white cursor-pointer w-44 bg-brandRed rounded-xl hover:bg-red-600">
                        <img src={plusIcon} alt="" />
                        {btnText}
                    </div>
                }
            </div>

            {/* Render the Filter Component conditionally */}
            {showFilter && FilterComponent && (
                <div className="fixed top-0 right-0 h-full w-[30%] bg-white border-l border-gray-300 z-10 overflow-auto hide-scrollbar">
                    <FilterComponent handleShowFilter={() => setShowFilter(false)} handleFilterData={handleFilterData} filterOptions={filterOptions} />
                </div>
            )}
        </div>
    );
}

export default React.memo(Index);